import { formatDistanceToNowStrict } from 'date-fns';

/**
 * Formats a date string into a relative time (e.g., "2 min ago", "3 hours ago")
 * @param {string|Date} date - The date to format
 * @returns {string} - The formatted relative time
 */
export const formatRelativeTime = (date) => {
    if (!date) return '';
    try {
        const d = new Date(date);
        if (isNaN(d.getTime())) return '';

        let relativeTime = formatDistanceToNowStrict(d, { addSuffix: true });

        // Optional: Shorten strings to match user's requested style exactly
        relativeTime = relativeTime
            .replace(' minutes', ' min')
            .replace(' minute', ' min')
            .replace(' hours', ' hour')
            .replace(' hour', ' hour')
            .replace(' days', ' day')
            .replace(' day', ' day')
            .replace(' months', ' month')
            .replace(' month', ' month')
            .replace(' years', ' year')
            .replace(' year', ' year');

        return relativeTime;
    } catch (error) {
        console.error('Error formatting date:', error);
        return '';
    }
};
